'use strict';

/**
 * Model for a single status
 *
 * @category   Collection
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var StatusModel = Model.extend({
    idAttribute: 'key',
    defaults: {
        key: '',
        name: '',
        hasRecipient: false,
        position: 1,
    },
});

module.exports = StatusModel;